import { SeoProps } from "../components/atoms/Seo";
import { A_PROPOS, DEVIS_BUFFET, GALERIE, HOME, LA_CARTE, MIDI_COMMANDES } from "./routing";

/**
 * Informations structurées JSON-LD (format Schema.org)
 * 
 * Utilisées pour :
 * - SEO / Référencement: les moteurs de recherche lisent ces données pour comprendre que le site représente un restaurant. Cela permet d'afficher des rich snippets dans les résultats de recherche (nom, adresse, téléphone, type de cuisine, gamme de prix).
 * - Knowledge Graph : Google peut intégrer ces infos dans son panneau latéral (la fiche qui apparaît à droite des résultats).
 * - Assistants vocaux / Maps : Les données structurées sont aussi exploitées par Google Maps, Siri, et les assistants vocaux pour répondre aux requêtes locales ("restaurant français à Saint-Brieuc").
 */
export const SEO_BUSINESS_INFO = {
  '@context': 'https://schema.org',
  '@type': 'FoodService',
  name: 'Mélusine Cantine',
  url: 'https://melusine-cantine.fr',
  servesCuisine: 'Cuisine du Monde, Flexitarienne',
  priceRange: '€€',
  description: [
    'Découvrez le traiteur qui serpente sur Saint-Brieuc !',
    'Une cuisine colorée et gourmande.',
    'Livraison de repas le midi mais aussi des buffets pour vos événements.'
  ].join(' ')
  // TODO ?
  // telephone: BUSINESS_INFO.telephone,
  // address: {
  //   '@type': 'PostalAddress',
  //   ...BUSINESS_INFO.address
  // }
  } as const;

export const seoMap = new Map<string, SeoProps>([
  [HOME, { title: 'Accueil' }],
  [LA_CARTE, { title: 'La carte' }],
  [GALERIE, { title: 'Galerie' }],
  [A_PROPOS, { title: 'A propos'}],
  [MIDI_COMMANDES, { title: 'Repas pour le midi ', metaDescription: 'Commander en ligne vos repas pour la pause déjeuner ! Des plats colorés et gourmands livrés sur votre lieu de travail ou chez vous, dans Saint-Brieuc Agglo.' }],
  [DEVIS_BUFFET, { title: 'Devis buffet événement', metaDescription: 'Vous avez un événement de prévu : anniversaire, vin d\'honneur, team bulding, séminaire, café d\'accueil, ... ? Remplissez notre formulaire pour recevoir un devis traiteur !' }]
])
